import React from "react"

const Marquee = ({ content = [], blockClassName = "", reverce = false }) => {
    if (!content.length) { return; }

    return <div className="marquee-component">
        <div className={`${blockClassName}`}>
            <div className="items-wrap">
                <div className={`items marquee d-flex ${reverce ? "reverce" : ""}`}>
                    {
                        content.map((item, index) => {
                            return <React.Fragment key={index}>
                                <div className="item">{item}</div>
                                <div className="item"><div className="point"></div></div>
                            </React.Fragment>
                        })
                    }
                    {
                        content.map((item, index) => {
                            return <React.Fragment key={index}>
                                <div className="item">{item}</div>
                                <div className="item"><div className="point"></div></div>
                            </React.Fragment>
                        })
                    }
                </div>
                <div aria-hidden="true" className={`items marquee ${reverce ? "reverce" : ""}`}>
                    {
                        content.map((item, index) => {
                            return <React.Fragment key={index}>
                                <div className="item">{item}</div>
                                <div className="item"><div className="point"></div></div>
                            </React.Fragment>
                        })
                    }
                    {
                        content.map((item, index) => {
                            return <React.Fragment key={index}>
                                <div className="item">{item}</div>
                                <div className="item"><div className="point"></div></div>
                            </React.Fragment>
                        })
                    }
                </div>
            </div>
        </div>
    </div>
}

export default Marquee;